module.exports = __webpack_public_path__ + "img/c1.5d79f17e.jpg";